import '../style.scss'
import { useContext, useState } from "react";
import { 
    AppSpan, Button, CenterPopupContainer, CheckBox, 
    Circle, 
    CustomContainer, FixedContainer, FlexRow, ScreenTitle 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { NewUserLayout } from 'src/component'
import { MdCheck } from 'react-icons/md'
import { IUserRole } from 'src/model';

export const NewUserRole: React.FC<any> = ({next, back, selectedUser, close}) => {
    const {info: {userCreationProcess}, setInfoProperty} = useContext(AppInfoContext)
    const [input, setInput] = useState<IUserRole>({
        adminAccess: userCreationProcess?.permission || selectedUser?.permissions || null, 
        superAdminAccess: userCreationProcess?.roleType === 'SUPERADMIN' ||selectedUser?.role?.name === 'SUPERADMIN' || false, 
        verificationAccess: false
    })

    async function handleNext() {
        await setInfoProperty('userCreationProcess', {
            ...userCreationProcess, 
            userRole: true,
            ...input, 
            permission: input.adminAccess ? 'crud' : 'read', 
            roleType: input.superAdminAccess ? 'SUPERADMIN' : 'ADMIN'
        })
        next()
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewUserLayout currentScreen='user-basics'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Assign user role to new user
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    <CustomContainer topMargin="4">
                        <FlexRow gap='1' bottomMargin='1.5' topMargin='5'>
                            <CheckBox
                                bgColor={(!input.adminAccess && input.adminAccess != null) ? '#5627FF' : 'transparent'}
                                borderColor={(!input.adminAccess && input.adminAccess != null) ? '#5627FF' : '#828282'}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                onClick={() => setInput({...input, adminAccess: false})}
                            >
                                { (!input.adminAccess && input.adminAccess != null) &&
                                    <MdCheck
                                        color='#ffffff' fontSize='1.8rem' 
                                    />
                                }
                            </CheckBox>
                            <AppSpan textSize='1.6' color='#111111'>
                                User (No Admin access)
                            </AppSpan>
                        </FlexRow>
                        <FlexRow gap='1' bottomMargin='1.5' topMargin='1.5'>
                            <CheckBox
                                bgColor={input.adminAccess ? '#5627FF' : 'transparent'}
                                borderColor={input.adminAccess ? '#5627FF' : '#828282'}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                onClick={() => setInput({...input, adminAccess: true})}
                            >
                                { input.adminAccess &&
                                    <MdCheck
                                        color='#ffffff' fontSize='1.8rem' 
                                    />
                                }
                            </CheckBox>
                            <AppSpan textSize='1.6' color='#111111'>
                                User (Admin access)
                            </AppSpan>
                        </FlexRow>
                    </CustomContainer>

                    <CustomContainer topMargin="4">
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Amet commodo consequat iaculis nisi tortor fringilla. Volutpat semper senectus 
                            proin facilisis nulla orci augue tristique. 
                        </AppSpan>
                        <FlexRow gap='1' bottomMargin='1.5' topMargin='4'>
                            <Circle
                                bgColor={input.superAdminAccess ? '#4F4F4F' : 'transparent'}
                                borderColor={input.superAdminAccess ? '#4F4F4F' : '#ABABAB'}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                onClick={() => setInput({...input, superAdminAccess: !input.superAdminAccess})}
                            >
                                { input.superAdminAccess &&
                                    <MdCheck
                                        color='#ffffff' fontSize='1.8rem' 
                                    />
                                }
                            </Circle>
                            <AppSpan textSize='1.6' color='#111111'>
                                Super Admin
                            </AppSpan>
                        </FlexRow>
                        <FlexRow gap='1' bottomMargin='1.5' topMargin='1.5'>
                            <Circle
                                bgColor={input.verificationAccess ? '#4F4F4F' : 'transparent'}
                                borderColor={input.verificationAccess ? '#4F4F4F' : '#ABABAB'}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                onClick={() => setInput({...input, verificationAccess: !input.verificationAccess})}
                            >
                                { input.verificationAccess &&
                                    <MdCheck
                                        color='#ffffff' fontSize='1.8rem' 
                                    />
                                }
                            </Circle>
                            <AppSpan textSize='1.6' color='#111111'>
                                Verification Access
                            </AppSpan>
                        </FlexRow>
                    </CustomContainer>
                    <FlexRow 
                        justifyContent="flex-end" 
                        topMargin="5" gap="1"
                    >
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff'
                            bgColor="#ffffff" 
                            hoverBorderColor='#5627FF'
                            hoverColor='#5627FF'
                            color="#5627FF"
                            onClick={back}
                        >
                            Back
                        </Button>
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            onClick={handleNext}
                        >
                            Next
                        </Button>
                    </FlexRow>
                </NewUserLayout>
            </FixedContainer>
        </>
    )
}